module.exports = __webpack_public_path__ + "img/continue.fa88a926.svg";